export default "__VITE_ASSET__CikxLnqC__"